import { FunctionComponent } from "react";
import styles from "./Container202.module.css";
const Container202: FunctionComponent = () => {
  return (
    <div className={styles.component5}>
      <img
        className={styles.a2f6cbe45867f82189117cQuoteIIcon}
        alt=""
        src="/63a2f6cbe45867f82189117c-quoteiconsvg.svg"
      />
      <div className={styles.heading2}>
        <div className={styles.portalDeliversCuttingEdge}>
          202 Portal delivers cutting-edge solutions, empowering businesses with
          digital transformation. Their strategic partnerships and
          professionalism make them the go-to choice for innovative technology
          services.
        </div>
      </div>
      <div className={styles.divwNode7902f10a4ea9D96b}>
        <div className={styles.divclientInfo}>
          <div className={styles.a441bfcbe18f0944da7010Client}>
            <img className={styles.image2Icon} alt="" src="/image-2@2x.png" />
          </div>
          <div className={styles.divclientDetailsWrap}>
            <div className={styles.janeMiller}>Jane Miller</div>
            <div className={styles.marketingManager}>Marketing Manager</div>
          </div>
        </div>
        <div className={styles.digitalTransformationCuttin}>
          digital transformation, cutting-edge solutions, strategic partnerships
        </div>
        <img className={styles.vectorIcon} alt="" src="/vector1.svg" />
        <img className={styles.vectorIcon1} alt="" src="/vector2.svg" />
      </div>
    </div>
  );
};

export default Container202;
